import { Focusable } from "@blacknut/spatialnav-sdk/dist";
import clsx from "clsx";
import React from "react";
import { Button, Modal, ModalProps } from "@blacknut/react-sdk";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as AngryImg } from "../../../assets/dist/ic_angry.svg";
import { ReactComponent as NotHappyImg } from "../../../assets/dist/ic_notHappy.svg";
import { ReactComponent as OkImg } from "../../../assets/dist/ic_ok.svg";
import { ReactComponent as HappyImg } from "../../../assets/dist/ic_happy.svg";
import { ReactComponent as VeryHappyImg } from "../../../assets/dist/ic_veryHappy.svg";

const FEEDBACK_TYPE = "postSession";

const Score = [
  { name: "angry", Icon: AngryImg },
  { name: "notHappy", Icon: NotHappyImg },
  { name: "ok", Icon: OkImg },
  { name: "happy", Icon: HappyImg },
  { name: "veryHappy", Icon: VeryHappyImg },
];

const FeedbackPostSessionModal = (
  props: ModalProps & {
    onClose: () => void;
    onSkipped: (type: string) => Promise<void>;
    onScore: (type: string, score: string) => Promise<void>;
  },
) => {
  const { onSkipped, onScore } = props;
  const { t } = useTranslation();

  return (
    <Modal
      {...props}
      className={styles.modal}
      buttons={[
        <Button
          variant="primary"
          key="ok"
          onClick={() => onSkipped(FEEDBACK_TYPE)}
          testID="confirm"
        >
          {t("buttons.skip")}
        </Button>,
      ]}
    >
      <h3 className={styles.title}>{t("feedback.postSession.title")}</h3>
      <h4 className={styles.subtitle}>{t("feedback.postSession.subtitle")}</h4>

      <ul className={styles.list}>
        {Score.map((s, i) => {
          const Icon = s.Icon;
          return (
            <div className={styles.scoreContainer} key={i} data-testid={`${s.name}`}>
              <Focusable
                component="li"
                className={clsx([styles.scoreItem, styles[s.name]])}
                onClick={() => onScore(FEEDBACK_TYPE, s.name)}
                onPressEnter={() => onScore(FEEDBACK_TYPE, s.name)}
              >
                {Icon && <Icon />}
              </Focusable>
              <h4 className={styles.scoreName}>{t(`feedback.postSession.${s.name}`)}</h4>
            </div>
          );
        })}
      </ul>
    </Modal>
  );
};

export default FeedbackPostSessionModal;
